// Whether a Google campaign's own schedule has finished (#6622). Google leaves a finished campaign at status
// ENABLED and derives "Ended" by comparing its end date with today, so a campaign that stopped running last year
// arrived here reading as live. The date is Google's, stated in the ad account's time zone, and the comparison
// here is the viewer's: a campaign ending today can therefore read as ended a few hours early for a viewer east of
// the account. The label is the only thing at stake, since discovery already refuses these and the state mirror
// moves the ones we hold out of live.
import type { CampaignData } from '@/lib/types';

type EndedFields = Pick<CampaignData, 'googleads_campaign'>;

/** The campaign's end date in Google Ads, or null when Google reported none. */
export function campaignEndDate(campaign: EndedFields): Date | null {
  const value = campaign.googleads_campaign?.end_date;
  if (!value) return null;
  const parsed = new Date(`${value}T00:00:00`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/** Whether the campaign's last serving day is behind today, which is what Google shows as "Ended". */
export function hasCampaignEnded(campaign: EndedFields): boolean {
  const endDate = campaignEndDate(campaign);
  if (endDate === null) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return endDate < today;
}
